import React from 'react';
import styles from './InvoiceDetails.module.css';
import EditableField from '../EditableField/EditableField';
import { useSelector } from 'react-redux';


const InvoiceDetails = ({ onApproverPage, formData, setFormData, allowEditing = false }) => {

    const userType = useSelector(state => state.graphql.accessLevel);
    const isLowestApprover = userType && userType.endsWith('1');

    const isApproverEditable = isLowestApprover && onApproverPage;
    const isEditableField = allowEditing || isApproverEditable;
    const canEditBackOfficeNote = isApproverEditable;
    const derivedFiscalYear = formData?.fiscalYear
        ?? (/^\d{4}-\d{2}-\d{2}$/.test(formData?.date || "") ? parseInt(formData.date.slice(0, 4), 10) : '');

    const handleChange = (fieldname, fieldvalue) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldname]: fieldvalue,
        }))
    };

    return (
        <table className={styles.itemTable}>
            <tbody>
            <tr>
                <th className={styles.label}>Sub Total ($)</th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.originalAmount} onChange={(update) => handleChange('originalAmount', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}>Currency</th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.currency} onChange={(update) => handleChange('currency', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}>GST ($)</th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.GST} onChange={(update) => handleChange('GST', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}>PST ($)</th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.PST} onChange={(update) => handleChange('PST', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}>Expense Type</th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.expenseType} onChange={(update) => handleChange('expenseType', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}>Category</th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.category} onChange={(update) => handleChange('category', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}>Sub-Category</th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.subCategory} onChange={(update) => handleChange('subCategory', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}> Project </th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.project} onChange={(update) => handleChange('project', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}> Entity </th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.entity} onChange={(update) => handleChange('entity', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}> Allocation </th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.allocation} onChange={(update) => handleChange('allocation', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}> Distance </th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.distance} onChange={(update) => handleChange('distance', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}> Details </th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.details} onChange={(update) => handleChange('details', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}> Capital </th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={formData.capital} onChange={(update) => handleChange('capital', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}> Fiscal Year </th>
                <th className={styles.control}><EditableField isEditing={isEditableField} initialData={derivedFiscalYear} onChange={(update) => handleChange('fiscalYear', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}> Submitted By </th>
                <th className={styles.control}><EditableField isEditing={false} initialData={formData.supplierEmail} onChange={(update) => handleChange('supplierEmail', update)} /></th>
            </tr>

            <tr>
                <th className={styles.label}> Back-office Note </th>
                <th className={styles.control}><EditableField isEditing={canEditBackOfficeNote} initialData={formData.backOfficeNote} onChange={(update) => handleChange('backOfficeNote', update)} /></th>
            </tr>
            </tbody>
        </table>
    )
}

export default InvoiceDetails;
